import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useMountEffect from './useMountEffect';

const useUrlQueryValue = (name: string) => {
  const history = useHistory();
  const [localValue, setLocalValue] = useState(() =>
    new URLSearchParams(history.location.search).get(name),
  );
  useMountEffect(() =>
    history.listen(() => {
      setLocalValue(new URLSearchParams(history.location.search).get(name));
    }),
  );

  return localValue;
};

export default useUrlQueryValue;
